import './assets/css/base.css'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue, {
  type BugsnagPluginVueResult,
} from '@bugsnag/plugin-vue'
import VueSplide from '@splidejs/vue-splide'
import mixpanel from 'mixpanel-browser'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginVue()],
  releaseStage: import.meta.env.MODE,
  autoTrackSessions: false,
})

Bugsnag.addOnError((event) => {
  if (event.errors[0].errorClass === 'FetchError') {
    const err = event.originalError as {
      url?: string
      res?: Response
      errors?: unknown
    }
    event.addMetadata('fetch', {
      url: err.url,
      status: err.res?.status,
      body: err.errors,
    })
  }
  if (event.errors[0].errorClass === 'TypeError') {
    // Ignore request errors that were the browser cancelling fetch() calls,
    // except checkout where we still want the report.
    if (
      [
        'cancelled',
        'Failed to fetch',
        'NetworkError when attempting to fetch resource.',
      ].includes(event.errors[0].errorMessage) &&
      event.context !== 'cart/checkout'
    )
      return false
  }
  console.log(event.originalError)
})

mixpanel.init(import.meta.env.VITE_MIXPANEL_API_KEY, {
  debug: import.meta.env.MODE !== 'production',
  api_host: 'https://api-eu.mixpanel.com',
})

import App from './App.vue'
import router from './router'

const bugsnagVue = Bugsnag.getPlugin('vue')
const app = createApp(App)

app.use(bugsnagVue as BugsnagPluginVueResult)
app.use(VueSplide)
app.use(createPinia())
app.use(router)

app.mount('#app')
